export const themeOptions = {
  palette: {
    primary: {
      light: '#08c5ab',
      main: '#006c5b',
      dark: '#217F70',
      contrastText: '#FFF'
    },
    secondary: {
      light: '#08c5ab',
      main: '#08c5ab',
      dark: '#08c5ab',
      contrastText: '#FFF'
    },
    default: {
      main: '#f9f9f9'
    },
    textSecondary: 'rgba(0, 169, 143, 1)'
  },
  /** Typographys **/
  typography: {
    fontFamily: ['Montserrat', 'Source Sans Pro'].join(','),

    body1: {
      fontWeight: 500
    }
  },

  /** Overrides **/
  overrides: {
    MuiPaper: {
      elevation1: {
        boxShadow: 'none'
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: '#FFF'
      }
    },
    MuiList: {
      root: {
        textAlign: 'center'
      }
    },
    MuiListItemText: {
      inset: {
        paddingLeft: '15px'
      }
    },
    MuiListItem: {
      root: {
        borderRadius: '50%',
        width: 50,
        height: 50,
        display: 'inline-flex',
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 10,
        marginBottom: 10,
        textAlign: 'center',
        justifyContent: 'center'
      },
      gutters: {
        paddingLeft: 0,
        paddingRight: 0
      },
      button: {
        background: '#a2a2a2',
        color: 'white',

        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)'
        }
      }
    },
    MuiListItemIcon: {
      root: {
        color: 'rgba(255, 255, 255, 0.7)',
        display: 'block',
        textAlign: 'center'
      }
    },
    MuiButton: {
      root: {
        borderRadius: '4px'
      }
    },
    MuiFab: {
      extended: {
        borderRadius: '4px',
        maxHeight: '39px'
      }
    },
    MuiInputBase: {
      root: {
        fontSize: 16
      }
    },
    MuiTableCell: {
      root: {
        padding: '0 16px',
        lineHeight: 1.5,
        fontSize: '0.775rem',
        borderBottom: '3px solid #fff'
      },
      stickyHeader: {
        backgroundColor: '#00A98F',
        color: '#FFF'
      }
    },
    MuiTableRow: {
      root: {
        cursor: 'pointer',
        padding: '0 16px',
        lineHeight: 1.5,

        '&:nth-child(odd)': {
          backgroundColor: '#efefef'
        },
        '&:nth-child(even)': {
          backgroundColor: '#FFF'
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: '5px'
      }
    },
    MuiTypography: {
      subtitle1: {
        padding: '5px 0'
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '1.2rem'
      }
    },
    MuiDialog: {
      paperFullScreen: {
        width: '100%',
        maxWidth: 1200,
        maxHeight: 700,
        borderRadius: 4
      }
    }
  }
};
